export default "__VITE_PUBLIC_ASSET__08cf5da5__"